<template>
  <!--签署详情-更多证据-->
  <div class="sign-log">
    <div class="s-con">
      <div v-if="applySignInfo" class="apply-info">
        <el-tooltip
          effect="dark"
          placement="bottom-start"
          :disabled="applySignInfo.contractName.length < 50"
          :content="applySignInfo.contractName"
        >
          <h3 class="font-ellipsis l-title" style="width: 70%">
            <i></i>
            {{ applySignInfo.contractName | ellipsis(50) }}
          </h3>
        </el-tooltip>
        <p>
          <span>文件编号：{{ applySignInfo.applyNo }}</span>
          <span>发起时间：{{ applySignInfo.createTime | formatDateTime }}</span>
          <span class="signStatus" :class="'s' + applySignInfo.signStatus">
            {{
            statusText
            }}
          </span>
        </p>
      </div>

      <div class="s-btn-box" v-if="applySignInfo">
        <!-- sdetailsDialog = true -->
        <el-button @click="turnEivHand" size="small" class="m-btn">
          <span class="el-icon-view" style="margin-right: 10px; color: #EC1C1C"></span>全证据链
        </el-button>
        <template v-if="applySignInfo && [1,4,5].includes(applySignInfo.signStatus)">
          <a
            v-if="applySignInfo.videnceFile"
            :href="downloadAttatchFile(applySignInfo.videnceFile || null)"
            target="_blank"
            class="el-button btn el-button--danger el-button--small z-btn"
          >
            <i class="t1"></i>
            <i class="t1 on"></i>证据包下载
          </a>
          <!-- <el-button v-if="applySignInfo.createType === 1" @click="gotoTestify" size="small" class="z-btn"><i class="t2"></i><i
          class="t2 on"></i>证据包出证</el-button>-->
          <!-- <el-button v-if="applySignInfo.createType === 1 && !currentIsCorpUser" @click="gotoRedirectTesity('ebaoquan')" size="small" class="z-btn"><i class="t2"></i><i
          class="t2 on"></i>证据包出证</el-button>-->
          <el-button
            v-show="
              [1,4,5].includes((applySignInfo || {}).signStatus) &&
              applySignInfo.createType === 1 &&
              $store.getters.hasAuthUser
            "
            @click="printCordDialog = true"
            size="small"
            class="z-btn"
          >
            <i class="t3"></i>
            <i class="t3 on"></i>防伪打印记录
          </el-button>
        </template>
      </div>

      <div class="s-table-wrap">
        <el-table
          v-if="applySignInfo"
          :data="applySignInfo.fileInfos"
          style="width: 100%"
          class="file-table"
          ooltip-effect="dark"
          empty-text="暂无数据"
          :header-cell-style="{
            background: '#f9f9f9',
            color: '#333333',
            fontWeight: '500',
          }"
        >
          <el-table-column label="签署文件" min-width="187">
            <template slot-scope="scope">{{ scope.row.fileName }}</template>
          </el-table-column>
        </el-table>
        <el-table
          v-if="applySignInfo"
          :data="applySignInfo.signInfos"
          style="width: 100%"
          tooltip-effect="dark"
          class="table-info"
          empty-text="暂无数据"
          :header-cell-style="{
            background: '#f9f9f9',
            color: '#333333',
            fontWeight: '500',
          }"
        >
          <el-table-column label="签署方" show-overflow-tooltip min-width="187">
            <template slot-scope="scope">
              {{ scope.row.fullName }}
              <br />
              {{
              scope.row.identityCardMask
              }}
            </template>
          </el-table-column>
          <el-table-column label="签署流水号" prop="signNo" min-width="187" show-overflow-tooltip />
          <el-table-column label="签署状态" width="160px">
            <template slot-scope="scope">
              <span v-if="scope.row.signStatus === 1" class="color-danger">已签署</span>
              <span v-else-if="scope.row.signStatus === 2" class="color-danger">拒签</span>
              <span v-else>未签署</span>
            </template>
          </el-table-column>
          <el-table-column label="签署时间" show-overflow-tooltip min-width="160px">
            <span slot-scope="scope">
              {{
              scope.row.signTime | formatDateTime
              }}
            </span>
          </el-table-column>
          <el-table-column
            label="签署现场"
            prop="address"
            class-name="table-cloumn"
            min-width="120"
            style="overflow: auto"
          >
            <template slot-scope="scope">
              <div class="mas-wrap">
                <el-badge
                  v-if="scope.row.evidenceList && scope.row.evidenceList.length"
                  :value="scope.row.evidenceList.length"
                  class="badge-evidence"
                >
                  <!--预览蒙层-->
                  <div class="msk">
                    <span @click="showEvidence(scope.row.evidenceList)">
                      <i class="el-icon-view"></i>预览
                    </span>
                  </div>
                  <img :src="scope.row.evidenceList[0].evidenceImg | showFiles" alt />
                </el-badge>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="签署地址" min-width="160px">
            <template slot-scope="scope" v-if="scope.row.addr">
              <img
                @click="showAddress"
                :src="getMapImg(scope.row.staticImg)"
                style="max-height: 60px;"
                alt="无法显示签署地址"
              />
              <p style="">
                {{ scope.row.addr }}
              </p>
            </template>
          </el-table-column>-->
        </el-table>
        <el-table
          v-if="newVideoInfo"
          :data="newVideoInfo"
          style="width: 100%"
          class="file-table"
          ooltip-effect="dark"
          empty-text="暂无数据"
          :header-cell-style="{
            background: '#f9f9f9',
            color: '#333333',
            fontWeight: '500',
          }"
        >
          <el-table-column label="视频通话记录">
            <template slot-scope="scope" v-if="scope.row.videoFile">
              {{
              scope.row.realStartTime
              ? scope.row.realStartTime
              : scope.row.endTime
              ? scope.row.endTime
              : scope.row.startTime
              }}
            </template>
          </el-table-column>
          <el-table-column label>
            <template slot-scope="scope">
              <div>
                <p>{{ scope.row.anchor.signatoryFullName }}</p>
                <p
                  v-for="item of scope.row.participants"
                  :key="item.signNo"
                >{{ item.signatoryFullName }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label>
            <template slot-scope="scope">
              <div v-if="scope.row.videoFile">
                <video width="300" height="150" controls autoplay muted>
                  <source
                    :src="`${GlobalConfig.domain.junziqianApi}/fileOper/download?fileType=${scope.row.videoFile.fileType}&sign=${scope.row.videoFile.sign}&targetId=${scope.row.videoFile.targetId}&ts=${scope.row.videoFile.ts}`"
                    type="video/mp4"
                  />
                </video>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-table
          v-if="attatchInfo.length > 0"
          :data="attatchInfo"
          style="width: 100%; margin-top: 20px"
          tooltip-effect="dark"
          class="table-info"
          :header-cell-style="{
            background: '#f9f9f9',
            color: '#333333',
            fontWeight: '500',
          }"
        >
          <el-table-column label="附件名称" width="425px" show-overflow-tooltip>
            <span slot-scope="attatch">{{ attatch.row.file.fileName }}</span>
          </el-table-column>
          <el-table-column label="附件编号" prop="attatchId" width="320px" />
          <el-table-column label="大小" width="225px">
            <span slot-scope="attatch">{{ attatch.row.file.fileSize / 1000 }}k</span>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="attatch">
              <a
                :href="downloadAttatchFile(attatch.row.file)"
                target="_blank"
                class="color-success"
              >下载文件</a>
              <!-- 图片和视频预览-->
              <a
                @click="previewVideOrImg(attatch.row)"
                v-if="isImg(attatch.row) || isVideo(attatch.row)"
                style="margin-left: 20px; cursor: pointer"
                class="color-success"
              >预览</a>
              <!-- 文档预览-->
              <a
                @click="previewDoc(attatch.row)"
                v-if="isDoc(attatch.row)"
                style="margin-left: 20px; cursor: pointer"
                class="color-success"
              >预览</a>
            </template>
          </el-table-column>
        </el-table>
        <!--   下载所有附件     -->
        <div style="text-align: right; padding: 10px 40px 0 0">
          <div
            style="cursor: pointer; display: inline-block"
            v-if="allDownloadFileData"
            @click="downloadAllFileFn"
            class="color-success"
          >下载全部附件</div>
        </div>
        <el-table
          v-if="LYList.length > 0"
          :data="LYList"
          style="width: 100%; margin-top: 20px"
          tooltip-effect="dark"
          class="table-info"
          :header-cell-style="{
            background: '#f9f9f9',
            color: '#333333',
            fontWeight: '500',
          }"
        >
          <el-table-column label="履约文件" show-overflow-tooltip>
            <span slot-scope="scope">
              {{ scope.row.fileName }}
              <br />
              <label
                style="color: #999999"
                v-if="scope.row.uploadType == 2"
              >备案号：{{ scope.row.presId }}</label>
            </span>
          </el-table-column>
          <el-table-column label="类型">
            <span slot-scope="scope">
              {{
              scope.row.uploadType == 1 ? "原文件" : "哈希"
              }}
            </span>
          </el-table-column>
          <el-table-column label="上传人">
            <span slot-scope="scope">{{ scope.row.userName }}-{{ scope.row.accountName }}</span>
          </el-table-column>
          <el-table-column label="上传时间">
            <span slot-scope="scope">
              {{
              scope.row.uploadTime | formatDateTime
              }}
            </span>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <a
                v-if="scope.row.uploadType == 1"
                :href="downloadAttatchFile(scope.row.file)"
                target="_blank"
                class="color-success"
              >下载</a>
              <a
                v-if="scope.row.uploadType == 2"
                @click="validLYFile(scope.row)"
                class="color-success"
                style="cursor: pointer"
              >验证</a>
              <!-- 图片和视频预览-->
              <a
                @click="previewVideOrImg(scope.row)"
                v-if="isImg(scope.row) || isVideo(scope.row)"
                style="margin-left: 20px; cursor: pointer"
                class="color-success"
              >预览</a>
              <!-- 文档预览-->
              <a
                @click="previewDoc(scope.row)"
                v-if="isDoc(scope.row)"
                style="margin-left: 20px; cursor: pointer"
                class="color-success"
              >预览</a>
            </template>
          </el-table-column>
        </el-table>

        <!--视频签署列表-->
        <template v-if="videoSignList && videoSignList.length">
          <div class="video-sign" style="margin-top: 20px">
            <h3>视频签署</h3>
            <el-table
              :data="videoSignList"
              style="width: 100%"
              tooltip-effect="dark"
              class="table-info"
              :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '500',
              }"
            >
              <el-table-column label="录制开始时间">
                <span slot-scope="scope">
                  {{
                  scope.row.startTime | formatDateTime
                  }}
                </span>
              </el-table-column>
              <el-table-column label="录制完成时间">
                <span slot-scope="scope">
                  {{
                  scope.row.endTime | formatDateTime
                  }}
                </span>
              </el-table-column>
              <el-table-column label="视频时长">
                <template slot-scope="scope">
                  <span v-if="scope.row.duration">
                    {{
                    scope.row.duration | secToTime
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="视频大小">
                <template slot-scope="scope">
                  <span v-if="scope.row.fileSize">
                    {{
                    Math.ceil((scope.row.fileSize / 1024 / 1024) * 100) / 100
                    }}Mb
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="参与人" prop="signNames" show-overflow-tooltip />
            </el-table>
          </div>
        </template>
      </div>
    </div>

    <div class="sign-info">
      <p class="t-info color-success">什么是证据包？</p>
      <p class="t-info">证据包是将签署过程中产生的一系列证据打包存档，包含签署过程日志、签署现场添加的附件、签署文件，如产生文件纠纷，可作为完整的证据链用于法庭举证</p>
      <p class="t-info color-success" style="margin-top: 15px">什么是证据包出证？</p>
      <p class="t-info">证据包用于法庭举证时，如需要纸质的公证书等，可以直接在线出具，邮寄到家。</p>
    </div>

    <!--过程证据弹窗-->
    <process-evidence :show.sync="sdetailsDialog" />

    <!--显示现场列表图片-->
    <el-dialog
      ref="evidenceBox"
      :visible.sync="visibleShowEvidence"
      width="70%"
      modal-append-to-body
      class="show-evidence__dailog"
    >
      <el-carousel
        v-if="evidenceList && evidenceList.length"
        height="500px"
        :autoplay="false"
        indicator-position="none"
        arrow="always"
      >
        <el-carousel-item
          v-for="(item, i) in evidenceList"
          :key="i"
          v-if="item.evidenceImg"
          class="img-item"
          :ref="'contbox-' + i"
        >
          <div class="video-box" style="display: none">
            <video controls="controls" height="500px">
              <source src type="video/mp4" />
              <source src type="video/webm" />
              <source src type="video/ogg" />您的浏览器不支持视频播放
            </video>
          </div>
          <div class="img-box">
            <img :src="item.evidenceImg | showFiles" alt />
            <img
              @click="
                playEvidenceVideo(item.evidenceVideo || null, 'contbox-' + i)
              "
              v-if="item.evidenceVideo"
              src="/images/m/play.png"
              class="play-video"
              alt
            />
          </div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <!--显示签署地址-->
    <el-dialog
      ref="addressBox"
      :visible.sync="visibleShowAddress"
      width="70%"
      modal-append-to-body
      class="show-evidence__dailog"
    >
      <el-carousel height="500px" :autoplay="false" indicator-position="none" arrow="never">
        <el-carousel-item class="img-item">
          <div class="img-box">
            <img style="width: 100%" :src="addressImg" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <!--防伪打印记录-->
    <el-dialog ref="addressBox" :visible.sync="printCordDialog" title="防伪打印记录" width="70%">
      <div
        style="text-align: right"
        v-show="
          (applySignInfo || {}).createType === 1 &&
          $store.getters.hasAuthUser &&
          applySignInfo.signStatus == 1
        "
      >
        <!--<el-button @click="goPrint()" style="margin-right:0px" size="small" class="m-btn">防伪打印</el-button>-->
      </div>
      <el-table :data="printList" tooltip-effect="dark">
        <el-table-column label="文件名称" prop="fileName" show-overflow-tooltip></el-table-column>
        <el-table-column label="文件哈希" prop="docHash" show-overflow-tooltip></el-table-column>
        <el-table-column label="防伪编码" prop="printNo" show-overflow-tooltip></el-table-column>
        <el-table-column label="时间" prop="createTime" show-overflow-tooltip></el-table-column>
        <el-table-column label="IP" prop="ip"></el-table-column>
        <el-table-column label="操作账号" prop="printer"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :visible.sync="certiDialog" title="选择出证签署方" width="30%" top="30vh">
      <div
        style="
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          padding: 10px 0 20px;
        "
      >
        <template v-for="(item, index) in certiList">
          <el-button
            @click="selectCerti(item)"
            style="margin-right: 10px"
            :key="index"
          >{{ item.idenName }}</el-button>
        </template>
      </div>
    </el-dialog>

    <!--pdf预览-->
    <ViewFilesToDoc
      :visibleShow="visibleShowEnclosureDoc"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      @setViewFilesToDocDialogData="onSetViewFilesToDocDialogData"
    />
    <!--附件图片video预览显示-->
    <ViewFilesToImg
      :visibleShow="visibleShowEnclosure"
      :isRefresh="isRefresh"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      :imgList="getEnclosureImgList"
      @setViewFilesToImgDialogData="onSetViewFilesToImgDialogData"
    />
  </div>
</template>

<script>
import {
  postApplySignMultiInfo,
  postApplySignInfo,
  postCheckFilesStatus,
  postFindAttatchInfo,
  getFindFileDownload,
  ApiMethods,
  fileOperShow,
  getStaticImg,
} from "../../assets/js/http-serve/http-methods";
import { loginOrRefresh } from "../../assets/js/http-serve/corp/common";
import VideoSign from "../../assets/js/http-serve/video-sign";
import ProcessEvidence from "@/components/processEvidence/index";
import ViewFilesToDoc from "@/components/viewFiles/ViewFilesToDoc";
import ViewFilesToImg from "@/components/viewFiles/ViewFilesToImg";
import GlobalConfig from "@/assets/js/config/global";
import { isInDingTalk } from '@/assets/js/utils/ding-env'

export default {
  components: {
    ProcessEvidence,
    ViewFilesToDoc,
    ViewFilesToImg,
  },
  computed: {
    userType () {
      return this.$store.getters.currentAuthUser.superFlag == 0 ||
        this.$store.getters.currentAuthUser.superFlag == 1
        ? 1
        : 0;
    },
    currentIsCorpUser () {
      let _currentAuthUser = this.$store.getters.currentAuthUser;
      if (_currentAuthUser && _currentAuthUser.corpId) {
        return true;
      }
      return false;
    },
    // 获取附件中的图片列表，用于预览
    getEnclosureImgList () {
      let v = [];
      let a = this.attatchInfo.filter((item) => {
        return this.isImg(item) || this.isVideo(item);
      });
      let b = this.LYList.filter((item) => {
        return this.isImg(item) || this.isVideo(item);
      });
      return v.concat(a).concat(b);
    },
    // 签署状态
    statusText () {
      switch (this.applySignInfo.signStatus) {
        case 0:
          return "未完成";
        case 1:
        case 5:
          return "已完成";
        case 2:
          return "拒签";
        case 4:
          return "已作废";
        case -4:
          return "审批驳回";
          break;
        case -5:
          return "已撤销";
        case -6:
          return "已失效";
        default:
          return "";
      }
    },
  },
  data () {
    return {
      allDownloadFileData: null,
      GlobalConfig,
      newVideoInfo: null,
      applySignInfo: null,
      attatchInfo: [],
      sdetailsDialog: false,
      // 证据列表
      evidenceList: null,
      visibleShowEvidence: false,
      visibleShowAddress: false,
      addressImg: "",
      videoSignList: null,
      printCordDialog: false,
      printList: [],
      certiList: [], // 签署方
      certiDialog: false, // 签署方选择弹窗
      printLoading: null,
      visibleShowEnclosure: false,
      visibleShowEnclosureDoc: false,
      enclosurePreviewNumItem: {}, // 当前预览项
      isRefresh: true, // 预览附件时，强制刷新
      LYList: [],
      multiFilesType: false, //判断当前合同信息是否是多文件发起
    };
  },
  filters: {
    showFiles: function (json) {
      if (!json) return "";
      const v = fileOperShow(json);
      return v;
    },
  },
  async beforeMount () {
    // 没有用户数据时，刷新页面，重新获取
    if (
      !(
        this.$store.getters.currentAuthUser.userName ||
        this.$store.getters.currentAuthUser.name
      )
    ) {
      let refreshRes = await loginOrRefresh();
      if (!refreshRes.success) {
        this.reload();
      }
    }
  },
  created () {
    let query = this.$route.query;
    postCheckFilesStatus(query)
      .then(({ data }) => {
        console.log(data.multiFiles);
        if (data.multiFiles) {
          this.multiFilesType = true;
          postApplySignMultiInfo(query)
            .then(({ data }) => {
              this.applySignInfo = data || null;
              (this.applySignInfo || {}).signStatus === 1 &&
                this.applySignInfo.createType === 1 &&
                this.$store.getters.hasAuthUser &&
                this.signPrintList();
              this.queryVideoSignList();
              // 如果是视频签署就查询详情
              Object.keys(data.applySignVideoInfoVO).length > 0 &&
                this.queryVideoInfo(query);
            })
            .catch((err) => {
              console.error("合同信息：" + JSON.stringify(err));
            });
        } else {
          postApplySignInfo(query)
            .then(({ data }) => {
              this.applySignInfo = data || null;
              (this.applySignInfo || {}).signStatus === 1 &&
                this.applySignInfo.createType === 1 &&
                this.$store.getters.hasAuthUser &&
                this.signPrintList();
              this.queryVideoSignList();
              // 如果是视频签署就查询详情
              Object.keys(data.applySignVideoInfoVO).length > 0 &&
                this.queryVideoInfo(query);
            })
            .catch((err) => {
              console.error("合同信息：" + JSON.stringify(err));
            });
        }
      })
      .catch((err) => {
        console.error("判断合同类型信息：" + JSON.stringify(err));
      });

    postFindAttatchInfo(query)
      .then((data) => {
        if (data.data) {
          this.attatchInfo = data.data;
        }
      })
      .catch((err) => {
        console.error("合同信息：" + JSON.stringify(err));
      });

    this.getLYList();
  },
  mounted () {
    this.showDownloadFileFn();
  },
  methods: {
    /** 跳转到全证据链页面 */
    turnEivHand () {
      const routeData = this.$router.resolve({
        path: '/applySign/fullEvidenceChain',
        query: {...this.$route.query}  // 传递当前页面的query参数
      });
      // 新开页面
      window.open(routeData.href, '_blank');
    },
    showDownloadFileFn () {
      ApiMethods.ApplySignController.downloadBatchAttatch(this.$route.query).then(result => {
        this.allDownloadFileData = result.data;
      })
    },
    //下载全部附件
    async downloadAllFileFn () {
      let param = {
        ...this.allDownloadFileData,
        fix: ".zip",
      };
      let res = await ApiMethods.FileOperController.download_get(param);
      if (res.success && res.url) {
        window.location.href = res.url;
      } else {
        this.$message.error(res.err);
      }
    },
    queryVideoInfo (query) {
      const { applyNo, signNo, sign, ts } = query;
      ApiMethods.CertApplyController.getVideoCallState({
        applyNo,
        signNo,
        sign,
        ts,
      }).then((res) => {
        if (!res.success) return this.$message.error(res.description);
        this.newVideoInfo = [res.data];
      });
    },
    async getLYList () {
      let query = this.$route.query;
      let res = await ApiMethods.PerformanceController.getDetailList(query);
      if (res.success) {
        this.LYList = res.data;
      } else {
        this.$message.error(res.description);
      }
    },
    // 执行预览图片视频关闭后参数回传
    onSetViewFilesToImgDialogData (data) {
      this.visibleShowEnclosure = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 执行预览PDF关闭后参数回传
    onSetViewFilesToDocDialogData (data) {
      this.visibleShowEnclosureDoc = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 获取附件后缀
    getEnclosureSuffix (item) {
      if (item && item.file && item.file.fileName) {
        let arr = item.file.fileName.split(".");
        return arr[arr.length - 1];
      }
      return "";
    },
    // 附件是否是图片
    isImg (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      let arr = ["PNG", "GIF", "JPG", "JPEG"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否是视频
    isVideo (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['MP4','RMVB','MKV','AVI']
      let arr = ["MP4", "WEBM", "OGG"];
      // let arr = ['MP4']
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否文档
    isDoc (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PDF"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 获取附件弹窗预览时初始图片index
    getInitIndex () {
      for (let i = 0; i < this.getEnclosureImgList.length; i++) {
        let item = this.getEnclosureImgList[i];
        if (item.attatchId === this.enclosurePreviewNumItem.attatchId) {
          return i;
        }
      }
      // return this.getEnclosureImgList.findIndex(item=>item.attatchId===this.enclosurePreviewNumItem.attatchId)
    },
    // 预览图片或者视频
    previewVideOrImg (item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosure = true;
      // 刷新预览弹窗，更新
      this.isRefresh = false;
      this.$nextTick(() => {
        this.isRefresh = true;
      });
    },
    // 预览文档
    previewDoc (item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosureDoc = true;
    },
    getId (id) {
      console.log(id);
      let res = id;
      for (let i = 0; i < 6 - id.toString().length; i++) {
        res = "0" + res;
      }
      return res;
    },
    signPrintList () {
      if (this.multiFilesType) {
        ApiMethods.SignPrintController.getSignMulti(this.$route.query).then(
          (res1) => {
            if (!res1.success)
              return this.$message.error(res1.description || "操作失败");
            ApiMethods.SignPrintController.signMultiPrintList(
              Object.assign(res1.data, {
                itemPage: 1,
                pageSize: 1000,
                userType: this.userType,
              })
            ).then((res) => {
              if (!res.success)
                return this.$message.error(res.description || "操作失败");
              this.printList = res.data;
            });
          }
        );
      } else {
        ApiMethods.SignPrintController.getSign(this.$route.query).then(
          (res1) => {
            if (!res1.success)
              return this.$message.error(res1.description || "操作失败");
            ApiMethods.SignPrintController.signPrintList(
              Object.assign(res1.data, {
                itemPage: 1,
                pageSize: 1000,
                userType: this.userType,
              })
            ).then((res) => {
              if (!res.success)
                return this.$message.error(res.description || "操作失败");
              this.printList = res.data;
            });
          }
        );
      }
    },
    //获取地图静态图片 （ 23-05-08 代老师说地图的接口隐藏调用）
    getMapImg (staticImg) {
      let param = {
        ts: this.$route.query.ts,
        sign: this.$route.query.sign,
        signNo: this.$route.query.signNo,
        staticImg: staticImg,
      };
      return (this.addressImg = getStaticImg(param));
    },
    // 获取视频签署列表
    queryVideoSignList () {
      if (this.applySignInfo) {
        VideoSign.getVideoSignList(this.applySignInfo.applyNo)
          .then(({ data }) => {
            this.videoSignList = data && data.length ? data : null;
          })
          .catch(() => { });
      }
    },
    // 现场证据
    showEvidence (evidence) {
      let evbox = this.$refs.evidenceBox.$el;
      if (evbox) {
        //打开证据列表前，先重置数据
        let imgbox = evbox.getElementsByClassName("img-box");
        let videobox = evbox.getElementsByClassName("video-box");
        for (var i = 0; i < imgbox.length; i++) {
          imgbox[i].style.display = "block";
        }
        for (var i = 0; i < videobox.length; i++) {
          videobox[i].style.display = "none";
        }
      }
      if (!evidence && !evidence.length) return false;
      this.evidenceList = evidence;
      this.visibleShowEvidence = true;
    },
    // 证据视频播放
    playEvidenceVideo (videoInfo, el) {
      if (!videoInfo || !el)
        return this.$message.error("该证据不是视频不能进行播放");
      var boxEl = this.$refs[el][0].$el;
      var url = this.showFile(videoInfo);

      if (url) {
        boxEl.querySelector(".img-box").style.display = "none";
        boxEl.querySelector(".video-box").style.display = "block";
        const videoElement = boxEl.querySelector("video");
        // boxEl.querySelector("video").src = url;
        // 移除所有现有的source标签（如果有的话）
        while (videoElement.firstChild) {
          videoElement.removeChild(videoElement.firstChild);
        }
        // 视频格式类型
        const videoType = ['video/mp4', 'video/webm', 'video/ogg'];
        for (let i = 0; i < videoType.length; i++) {
          const type = videoType[i];
          // 创建新的source标签
          const source = document.createElement('source');
          source.src = url;
          source.type = type;
          // 将新的source标签添加到video标签中
          videoElement.appendChild(source);
          // 如果你需要立即加载视频，可以调用 load 方法
          videoElement.load();
        }
      }
    },
    //签署地址显示
    showAddress () {
      this.visibleShowAddress = true;
    },
    // 文件显示
    showFile (json) {
      if (!json) return "";
      const v = fileOperShow(json);
      // console.info('.........', v);
      return v;
    },
    async gotoRedirectTesity (code) {
      let _this = this;
      if (!_this.applySignInfo) return false;
      var _param = {
        signNo: this.applySignInfo.signInfoNo || "",
        applyNo: this.applySignInfo.applyNo || "",
      };
      let viewUrlParam = { signNo: _param.signNo, applyNo: _param.applyNo };
      let viewUrlRes = await ApiMethods.UserApplySignController.viewUrl(
        viewUrlParam
      );
      if (!viewUrlRes.success) {
        return _this.$message.error(
          viewUrlRes.description || "初始化数据失败1"
        );
      }
      _param = viewUrlRes.data;
      let certiRes = await ApiMethods.ApplySignController.certi(_param);
      if (!certiRes.success) {
        return this.$message.error(certiRes.description);
      }
      let ow = window.open("about:blank"),
        redirectTesityParam = certiRes.data;
      redirectTesityParam.code = code;
      let redirectTesityRes = await ApiMethods.CertiController.redirectTesity(
        redirectTesityParam
      );
      if (redirectTesityRes.success) {
        ow.location.href = redirectTesityRes.data;
      } else {
        _this.$message.error(redirectTesityRes.description || this.$tip);
        ow.close();
      }
    },
    gotoTestify () {
      if (!this.applySignInfo) return false;
      var _this = this;
      var param = {
        signNo: this.applySignInfo.signInfoNo || "",
        applyNo: this.applySignInfo.applyNo || "",
      };

      ApiMethods.UserApplySignController.viewUrl(param)
        .then((viewResult) => {
          //{"applyNo":"","ts":,"sign":"","signNo":""}
          if (!viewResult.success) {
            return _this.$message.error(
              viewResult.description,
              "初始化数据失败"
            );
          }
          if (viewResult.data && viewResult.data.signNo) {
            ApiMethods.ApplySignController.certi(viewResult.data).then(
              (redirectResult) => {
                var newWindow = window.open();
                if (redirectResult.success) {
                  // _this.$router.push({path:"/certi/certiPage", query : redirectResult.data});
                  var { href } = _this.$router.resolve({
                    path: "/certi/certiPage",
                    query: redirectResult.data,
                  });
                  newWindow.location.href = window.location.origin + href;
                } else {
                  newWindow.close();
                  _this.$message.error(redirectResult.description);
                }
              }
            );
          } else {
            ApiMethods.ApplySignController.certiList(viewResult.data).then(
              (res) => {
                if (res.success) {
                  _this.certiDialog = true;
                  _this.certiList = res.data;
                } else {
                  _this.$message.error(res.description);
                }
              }
            );
          }
        })
        .catch((err) => {
          _this.$message.error(err.description);
        });
    },
    selectCerti (data) {
      var _this = this;
      var newWindow = window.open();
      var { href } = _this.$router.resolve({
        path: "/certi/certiPage",
        query: data,
      });
      isInDingTalk ? this.$router.push(href) : newWindow.location.href = window.location.origin + href;
      this.certiDialog = false;
    },
    downloadAttatchFile (param) {
      if (!param || param === "null" || param === "false")
        return "javascript:void(0)";
      if (param.fileName === "blob") {
        param.fileName = "attachment.png";
        param.fix = ".png";
      }
      return getFindFileDownload(param);
    },
    closeWin: function () {
      window.close();
    },

    //点击防伪打印
    goPrint () {
      this.printLoading = this.$loading({ lock: true });
      ApiMethods.SignPrintController.getSign(this.$route.query)
        .then((res1) => {
          if (!res1.success)
            return this.$message.error(res1.description || "操作失败");
          ApiMethods.SignPrintController.printStatus(
            Object.assign(res1.data, { userType: this.userType })
          )
            .then((res2) => {
              if (!res2.success)
                return this.$message.error(res2.description || "操作失败");
              if (res2.data.needPay) {
                this.$confirm(
                  `需消耗${res2.data.point}积分,支付成功后24小时内可重复打印，超出时间后将再次收费。`,
                  "支付提示",
                  {
                    showConfirmButton: true,
                    showCancelButton: true,
                    type: "info",
                  }
                ).then(() => {
                  ApiMethods.SignPrintController.order(
                    Object.assign(res1.data, {
                      userType: this.userType,
                      pay: 1,
                    })
                  )
                    .then((res) => {
                      if (+res.code === 10806) {
                        this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                        return;
                      }
                      if (+res.code === 0) {
                        let { href } = this.$router.resolve({
                          path: "/applySign/contractPrint",
                          query: this.$route.query,
                        });
                        location.href = window.location.origin + href;
                        return;
                      }
                      this.$message.error(res.description || "支付失败");
                    })
                    .finally(() => this.printLoading.close());
                });
              } else {
                let { href } = this.$router.resolve({
                  path: "/applySign/contractPrint",
                  query: this.$route.query,
                });
                location.href = window.location.origin + href;
              }
            })
            .finally(() => this.printLoading.close());
        })
        .finally(() => this.printLoading.close());
    },
    validLYFile (item) {
      // window.open('https://www.ebaoquan.org/query?type=2', '_blank');
      // window.open('http://sandbox.ebaoquan.org/query?type=2&bah=' + item.presId, '_blank');
      const url = `${this.globalConfig.domain.portal}/query?type=2&bah=${item.presId}`;
      isInDingTalk ? location.href = url : window.open(url, "_blank");
    },
  },
  name: "toSignlog",
  layout: "fullpage",
  head: {
    title: "签署详情"
  }
};
</script>

<style lang="less" scoped>
.enclosure-dialog {
  /*/deep/ .el-dialog__body {*/
  /*  padding: 0;*/
  /*}*/

  /deep/ .el-dialog__headerbtn {
    z-index: 5;
  }

  .h-title {
    background: #ffffff;
    z-index: 2;
    line-height: initial;
    text-align: left;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    padding: 10px;
    width: 100%;
    /*position: absolute;*/
    /*top:0;*/
    /*left:0;*/
    /*right: 0;*/
    border-bottom: 1px solid #eeeeee;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    box-sizing: border-box;
  }

  .box-wrap {
    height: 460px;
    line-height: 430px;
    padding: 15px;
    box-sizing: border-box;

    img {
      max-height: 430px;
    }
  }
}

.video-sign {
  margin-bottom: 20px;

  h3 {
    background: #ec1c1c;
    color: #ffffff;
    line-height: 1.47;
    padding: 7px 10px;
  }
}

.sdetails-dialog {
  .sdetails {
    height: 450px;
    overflow-x: hidden;
    margin: -20px -20px -10px;
    padding: 0 20px 40px;

    .sdetails-item {
      padding: 20px 0;
      border-bottom: 1px solid #e7e7e7;
    }

    b {
      color: #009899;
    }

    h5 {
      margin: 0;
      color: #009899;
      font-size: 15px;
      font-weight: 600;
      margin-bottom: 6px;
    }

    p {
      color: #333;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.5;
      word-break: break-all;
    }
  }
}

.table-info {
  /*border: 1px solid #ebebeb;*/
  border-bottom: 0;

  .badge-evidence {
    img {
      width: 100%;
      max-width: 100px;
      max-height: 80px;
      display: block;
      cursor: pointer;
    }
  }

  /deep/ .el-table__header {
    width: 100% !important;
  }

  /deep/ .el-table__body {
    width: 100% !important;
  }
}

.sign-info {
  /*border: 1px solid #ebebeb;*/
  padding-top: 40px;
  padding-bottom: 65px;

  .t-info {
    /*padding-left: 10px;*/
    color: rgba(0, 0, 0, 0.85);
  }

  .btn {
    min-width: 70px;
  }

  .close-btn {
    padding: 60px;
  }

  .color-success {
    color: #189f9e;
  }
}

.s-btn-box {
  padding: 20px 15px 30px 15px;
}

.m-btn {
  line-height: 35px;
  padding: 0;
  /*background: rgba(236, 28, 28, 1);*/
  color: #ec1c1c;
  border: 1px solid rgba(236, 28, 28, 1);
  opacity: 1;
  border-radius: 4px;
  margin-right: 20px;
  box-sizing: border-box;
  min-width: 120px;

  &:focus {
    background: rgba(236, 28, 28, 1);
    color: #ffffff;
    border: 1px solid rgba(236, 28, 28, 1);
  }

  /*&:hover{*/
  /*  background: #EC1C1C !important;*/
  /*  color: #ffffff !important;*/
  /*  opacity: 0.7;*/
  /*}*/
}

.z-btn {
  line-height: 35px;
  padding: 0;
  background: #ffffff;
  opacity: 1;
  border-radius: 4px;
  color: #ec1c1c;
  margin-right: 20px;
  box-sizing: border-box;
  min-width: 120px;
  border: 1px solid rgba(236, 28, 28, 1);

  &:hover {
    background: #ec1c1c !important;
    color: #ffffff !important;
    opacity: 1 !important;

    i {
      display: none;
    }

    .on {
      display: inline-block;
    }
  }

  &:focus {
    background: #ffffff;
    color: #ec1c1c;
    border: 1px solid rgba(236, 28, 28, 1);
  }

  i {
    vertical-align: middle;
    margin-right: 10px;
    display: inline-block;
    width: 15px;
    height: 15px;

    &.on {
      display: none;
    }
  }
}

.s-table-wrap {
  padding: 0 15px 47px 15px;
}

.apply-info {
  padding-bottom: 20px;
  padding-top: 15px;
  border-bottom: 1px solid #f2f2f2;
  /*border: 1px dashed #e5e5e5;*/

  .l-title {
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    text-align: left;
    padding: 3px 0;
    margin-bottom: 10px;
    font-weight: bold;

    > i {
      width: 5px;
      height: 15px;
      background: rgba(38, 38, 38, 1);
      opacity: 1;
      border-radius: 100px;
      display: inline-block;
      margin-right: 10px;
      vertical-align: inherit;
    }
  }

  p {
    font-size: 14px;
    margin: 0 15px;
    background: rgba(248, 248, 248, 1);
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 2;
    padding: 0 5px;
    position: relative;

    span {
      display: inline-block;
      margin-right: 50px;
      font-size: 14px;
    }
    .signStatus {
      text-align: center;
      border: 1px solid #ec7e1c;
      border-radius: 2px;
      line-height: 1;
      vertical-align: middle;
      padding: 2px 5px;
      display: inline-block;
      margin: 0px;
      font-size: 14px;
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
    }
    .signStatus.s0,
    .signStatus.s4 {
      border: 1px solid #ec7e1c;
      color: #ec7e1c;
    }
    .signStatus.s1,
    .signStatus.s5 {
      border: 1px solid #009899;
      color: #009899;
    }
    .signStatus.s2 {
      border: 1px solid #ec1c1c;
      color: #ec1c1c;
    }
    .signStatus.s-4 {
      border: 1px solid #ec1c1c;
      color: #ec1c1c;
    }
    .signStatus.s-5 {
      border: 1px solid #ec1c1c;
      color: #ec1c1c;
    }
    .signStatus.s-6 {
      border: 1px solid #ec1c1c;
      color: #ec1c1c;
    }
  }

  h3 {
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 10px;
    line-height: 1.1;
  }
}

.sign-log {
  max-width: 1200px;
  margin: 0 auto;
}

.s-con {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.02);
}
/deep/ .file-table.el-table {
  tr td {
    box-sizing: border-box;
    height: 50px;
  }
}
/deep/ .el-table {
  table-layout: fixed;
  margin-top: 15px;
  /*border-bottom: 1px solid #EBEEF5;*/

  thead tr th {
    box-sizing: border-box;
    padding: 0;
    height: 50px;
    color: rgba(0, 0, 0, 0.65);
  }

  tr td {
    box-sizing: border-box;
    height: 100px;
  }

  tr:hover td {
    background: #fff2e6;
  }

  tr:nth-child(even) {
    background: rgba(248, 248, 248, 1);
  }

  td,
  th.is-leaf {
    border-bottom: none;
  }

  th.is-leaf {
    background: #f9f9f9;
  }
}

.mas-wrap {
  position: relative;
  display: inline-block;

  &:hover {
    .msk {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }

  .msk {
    transition: all 0.2s ease;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    left: 0;
    top: 0;
    width: 0;
    height: 0;
    color: #ffffff;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    opacity: 0;

    > span {
      cursor: pointer;
      display: inline-block;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
    }

    i {
      margin-right: 5px;
    }
  }

  /deep/ .el-badge__content {
    z-index: 3;
  }
}

.t1 {
  background: url("../../assets/images/icon_t1.png");
  background-size: 100% 100%;
}

.t1.on {
  background: url("../../assets/images/icon_t1_on.png");
  background-size: 100% 100%;
}

.t2 {
  background: url("../../assets/images/icon_t2.png");
  background-size: 100% 100%;
}

.t2.on {
  background: url("../../assets/images/icon_t2_on.png");
  background-size: 100% 100%;
}

.t3 {
  background: url("../../assets/images/icon_t3.png");
  background-size: 100% 100%;
}

.t3.on {
  background: url("../../assets/images/icon_t3_on.png");
  background-size: 100% 100%;
}
</style>

<style lang="less">
.show-evidence__dailog {
  text-align: center;
  vertical-align: middle;

  .img-item {
    line-height: 500px;

    .play-video {
      position: absolute;
      top: 240px;
      left: 50%;
      cursor: pointer;
    }
  }

  img {
    max-width: 100%;
    max-height: 500px;
    vertical-align: middle;
  }
}

.table-info {
  .table-cloumn {
    img {
      max-height: 80px;
      max-width: 100px;
      display: block;
      vertical-align: middle;
    }

    .cell {
      padding-top: 10px;
      // overflow: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/applySign/toSignlog.vue